import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

/**
 * Fase A1 · la puerta de los datos sensibles.
 *
 * NINGUNA de estas llamadas manda un identificador de persona: la identidad la resuelve el
 * servidor desde el token. Si lo mandara, alguien podría pedir la ventana de otro.
 */

/** ¿Puede abrir datos sensibles, o tiene que configurar el segundo factor primero? */
export const fetchEstadoSeguridad = async () => {
    const r = await axios.get(`${API_URL}/api/seguridad/estado`, auth());
    return r.data;
};

/** Verifica el código y devuelve la ventana. Lanza con el cuerpo del error para que la puerta
 *  pueda distinguir «no lo tiene configurado» de «código incorrecto». */
export const fetchVerificarSegundoFactor = async (codigo) => {
    const r = await axios.post(`${API_URL}/api/seguridad/verificar-2fa`, { codigo }, auth());
    return r.data;
};

/** Alarga la ventana viva lo que dura la de su rol (+10 o +5, tope 60 desde el código). Devuelve la
 *  ventana nueva con la misma forma que `fetchVerificarSegundoFactor`. Lanza con el cuerpo del
 *  error: TOPE_ALCANZADO o VENTANA_CADUCADA. */
export const fetchProrrogarVentana = async (ventana) => {
    const r = await axios.post(`${API_URL}/api/seguridad/prorrogar-ventana`, {},
        { headers: { ...auth().headers, 'x-ventana-2fa': ventana } });
    return r.data;
};

/** El estado del segundo factor DE OTRA PERSONA, para la ficha. No devuelve ningún secreto:
 *  dice si lo tiene, no cuál es. Protegida por rol en el servidor. */
export const fetchSegundoFactorDePersona = async (id, tipo = null) => {
    const q = tipo === 'colaboradora' ? '?tipo=colaboradora' : '';
    const r = await axios.get(`${API_URL}/api/persona/${id}/segundo-factor${q}`, auth());
    return r.data;
};

/** Lo retira para que la persona pueda volver a configurarlo — lo que hace falta cuando alguien
 *  pierde el móvil. No lo configura por ella: eso sólo puede hacerlo quien tenga la aplicación. */
export const fetchRestablecerSegundoFactor = async (id, tipo = null) => {
    const q = tipo === 'colaboradora' ? '?tipo=colaboradora' : '';
    const r = await axios.post(`${API_URL}/api/persona/${id}/segundo-factor/restablecer${q}`, {}, auth());
    return r.data;
};
